import React from "react";
import SideNav from "../libs/SideNav";
import { Frame } from "./style";
import SideNavHeader from "../../components/header/HeaderUser";
import AdminTopNav from "../../components/header/Header";
import TokenHelpers from "../../utils/helpers/tokenHelper";
import { getAccountPathByName } from "../../utils/helpers/getAccountTypeName";

export default function MainDashboardLayout({ type, children, ...props }) {
  const account_type = TokenHelpers.getFromStorage("account_type");
  const account_path = getAccountPathByName(account_type);
  const pathname = window.location.pathname;
  const handleClick = (e) => {};

  const handleSideNavToggle = () => {};
  const isMessage =
    pathname === "/dashboard/user/messages" ||
    pathname === "/dashboard/super-admin/messages" ||
    pathname === "/dashboard/system-admin/messages";
  const isUser = account_type === "USER";
  const isHomePage = (pathname === "/" || pathname === "/dashboard/user/home") && isUser;
  const showTopNav = (pathname === "/" || pathname === "/dashboard/user/home") && isUser;

  return (
    <Frame isMessage={isMessage}>
      {!isHomePage && (
        <SideNav
          type={account_path}
          pathname={props?.location?.pathname}
          onClick={handleClick}
          sideNavToggle={handleSideNavToggle}
          isMessage={isMessage}
        />
      )}
      <div className="md:px-5">
        {showTopNav && (
          <SideNavHeader email={TokenHelpers.getUserDetails().sub} isAdmin={!isUser}/>
        )}
        {!(isMessage || isUser) && (
          <AdminTopNav email={TokenHelpers.getUserDetails().sub} isAdmin={!isUser} account_path={account_path}/>
        )}
        <div>{children}</div>
      </div>
    </Frame>
  );
}
